import "@babel/polyfill";
import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import store from "./store";
import "./registerServiceWorker";
import "./assets/css/style.css";
import "./assets/css/train.css";
import "./assets/css/itcalculation.css";
import "./assets/css/font-awesome.min.css";
import "../node_modules/element-ui/lib/theme-chalk/index.css";
import ElementUI from "element-ui";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
let dates = require("./assets/js/dates");
let json = require("./assets/js/data");
Vue.prototype.data = json.default;
var Clipboard = require("clipboard");
Vue.prototype.Clipboard = Clipboard;
var toast = require("@/components/toast/index.js");
Vue.use(toast);
const $ = require("jquery");
Vue.prototype.$axios = axios;
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.dates = dates.default;
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  },
});

import { Button, ActionSheet, Rate, Swipe, SwipeItem, Icon, Badge } from "vant";
import 'vant/lib/index.css';
Vue.use(Button);
Vue.use(ActionSheet)
Vue.use(Rate)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Icon)
Vue.use(Badge)
// Viewer.setDefaults({
//   Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
// })
// Vue.config.errorHandler = function (err,vm,info) {
//   alert(err)
//   alert(info)
// }
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
